/* eslint-disable sonarjs/no-duplicate-string */
import { ReactComponent as AccessIcon } from '@paradigm/icons/src/mailru/categories/access.svg';
import { ReactComponent as CartIcon } from '@paradigm/icons/src/mailru/navigation/cart.svg';
import { ReactComponent as DoneIcon } from '@paradigm/icons/src/mailru/status/done.svg';
import theme from '@paradigm/tokens/cloud';
import { ReactComponent as ArrowBlueDownIcon } from 'img/icons/arrow-blue-down.svg';
import { ReactComponent as ArrowBlueUpIcon } from 'img/icons/arrow-blue-up.svg';
import { ReactComponent as ComboIcon } from 'img/icons/combo2.svg';
import { ReactComponent as DiskoIcon } from 'img/icons/disko.svg';
import { ReactComponent as HistoryIcon } from 'img/icons/history.svg';
import { ReactComponent as MarkIcon } from 'img/icons/mark2.svg';
import { ReactComponent as NoadsIcon } from 'img/icons/noads.svg';
import { ReactComponent as UploadIcon } from 'img/icons/uploads2.svg';
import { ReactComponent as ComboNewIcon } from 'img/icons/vk_combo.svg';
import React, { ReactElement, ReactNode } from 'react';
import { openDisko } from 'reactApp/constants/products/features.constants';
import { quotaFeatures } from 'reactApp/constants/products/quotaFeatures';
import { MailIcon, TrashbinIcon } from 'reactApp/ui/VKUIIcons';

export interface IFeatureData {
    /**
     * Вместо text лучше использовать ?textJsx, если есть
     * В старом компоненте string использовался в dangerouslySetInnerHTML
     * @deprecated
     */
    text: string;
    textJsx?: ReactNode;
    key: string;
    icon?: ReactElement;
    onClick?();
    delimiters?: boolean;
}

const baseFeatures: Record<string, IFeatureData[]> = {
    noads: [
        {
            text: 'Без рекламы',
            key: 'noads',
            icon: <MarkIcon width={12} height={11} />,
        },
    ],
    noadsPro: [
        {
            text: 'Без рекламы',
            key: 'noads',
            icon: <NoadsIcon width={16} height={16} />,
        },
    ],
    paidFeatures: [
        {
            text: 'Версионирование',
            key: 'versions',
            icon: <MarkIcon width={12} height={11} />,
        },
    ],
    upload: [
        {
            text: 'Загрузка файлов до\u00A032\u00A0ГБ',
            key: 'upload',
            icon: <MarkIcon width={12} height={11} />,
        },
    ],
    autodelete: [
        {
            text: 'Автоудаление папок',
            key: 'autodelete',
            icon: <MarkIcon width={12} height={11} />,
        },
    ],
    baseUpload: [
        {
            text: 'Загрузка файлов до\u00A02\u00A0ГБ',
            key: 'baseUpload',
            icon: <MarkIcon width={12} height={11} />,
        },
    ],
    corpUpload: [
        {
            text: 'Загрузка файлов до\u00A0100\u00A0ГБ',
            key: 'corpUpload',
            icon: <MarkIcon width={12} height={11} />,
        },
    ],
    giftsOpen: [
        {
            text: 'Плюс подарки',
            key: 'giftsOpen',
            icon: <ArrowBlueDownIcon width={11} height={7} />,
        },
    ],
    giftsClose: [
        {
            text: 'Плюс подарки',
            key: 'giftsClose',
            icon: <ArrowBlueUpIcon width={11} height={7} />,
        },
    ],
    disko: [
        {
            text: 'Без рекламы',
            key: 'ad',
        },
        {
            text: 'Загрузка файлов до\u00A032\u00A0ГБ',
            key: 'upload',
            icon: <MarkIcon width={12} height={11} />,
        },
        {
            text: 'Автоудаление папок',
            key: 'autodelete',
            icon: <MarkIcon width={12} height={11} />,
        },
        {
            text: '30 дней истории изменений файлов',
            key: 'hist',
            icon: <HistoryIcon width={22} height={22} />,
        },
        {
            text: 'Доступ ко\u00A0всем возможностям Диск&#8209;О:',
            key: 'disko',
            icon: <DiskoIcon width={23} height={17} />,
        },
    ],
    modalPro: [
        {
            text: 'Без рекламы',
            key: 'ad',
        },
        {
            text: 'Загрузка файлов до\u00A0100\u00A0ГБ',
            key: 'upload',
        },
        {
            text: 'Автоудаление папок',
            key: 'autodelete',
        },
        {
            text: '60 дней истории изменений файлов',
            key: 'hist',
        },
        {
            text: 'Доступ ко\u00A0всем возможностям Диск&#8209;О:',
            key: 'disko',
        },
        {
            text: 'Скидки и бонусы от партнеров',
            key: 'discount',
        },
    ],
    singleQuota: [
        {
            text: 'Без рекламы в Почте и Облаке',
            key: 'ad',
        },
        {
            text: 'Загрузка файлов до\u00A0100\u00A0ГБ в Облако',
            key: 'upload',
        },
        {
            text: 'Отправка файлов до\u00A0100\u00A0ГБ в письмах',
            key: 'sending',
        },
        {
            text: 'Автоудаление папок',
            key: 'autodelete',
        },
        {
            text: 'Приоритетная поддержка',
            key: 'support',
        },
    ],
    singleQuotaPro: [
        {
            text: 'Без рекламы в Почте и Облаке',
            key: 'ad',
        },
        {
            text: 'Загрузка файлов до\u00A0100\u00A0ГБ в Облако',
            key: 'upload',
        },
        {
            text: 'Отправка файлов до\u00A0100\u00A0ГБ в письмах',
            key: 'sending',
        },
        {
            text: 'Автоудаление папок',
            key: 'autodelete',
        },
        {
            text: 'Приоритетная поддержка',
            key: 'support',
        },
        {
            text: '60 дней истории изменений файлов',
            key: 'hist',
        },
        {
            text: 'Доступ ко\u00A0всем возможностям Диск-О:',
            key: 'disko',
        },
        {
            text: 'Скидки и бонусы от партнеров',
            key: 'discount',
        },
    ],
    // TODO выпилить когда полностью перейдем на TariffSectionNew
    professional: [
        {
            text: 'Без рекламы',
            key: 'noads',
            icon: <NoadsIcon width={18} height={18} />,
        },
        {
            text: 'Загружайте файлы до\u00A0100\u00A0ГБ\nбез\u00A0ограничений',
            key: 'gb100',
            icon: <UploadIcon width={20} height={21} />,
        },
        {
            text: 'Автоудаление папок',
            key: 'autodelete',
            icon: <TrashbinIcon />,
        },
        {
            text: '60 дней истории изменений файлов',
            key: 'hist',
            icon: <HistoryIcon width={22} height={22} />,
        },
        {
            text: 'Доступ ко\u00A0всем возможностям <span style="color: #0470ff">Диск&#8209;О:</span>',
            key: 'disko',
            icon: <DiskoIcon width={23} height={17} />,
            onClick: openDisko,
        },
        {
            text: 'Подписка VK Combo на 3\u00A0месяца\u00A0в подарок!',
            key: 'combo',
            icon: <ComboIcon width={23} height={24} />,
        },
    ],
    // TODO выпилить когда полностью перейдем на TariffSectionNew
    professional6M: [
        {
            text: 'Без рекламы',
            key: 'noads',
            icon: <NoadsIcon width={18} height={18} />,
        },
        {
            text: 'Загружайте файлы до\u00A0100\u00A0ГБ<br />без\u00A0ограничений',
            key: 'gb100',
            icon: <UploadIcon width={20} height={21} />,
        },
        {
            text: '60 дней истории изменений файлов',
            key: 'hist',
            icon: <DoneIcon fill="#005FF9" width={22} height={22} />,
        },
        {
            text: 'Доступ ко\u00A0всем возможностям <span style="color: #0470ff">Диск-О:</span>',
            key: 'disko',
            icon: <DiskoIcon width={23} height={17} />,
            onClick: openDisko,
        },
        {
            text: 'Подписка VK Combo на 1\u00A0месяц\u00A0в подарок!',
            key: 'combo',
            icon: <ComboIcon width={23} height={23} />,
        },
    ],
    professional_new: [
        {
            text: 'Без рекламы',
            key: 'noads',
            icon: <DoneIcon fill="#005FF9" width={16} height={16} />,
        },
        {
            text: 'Загружайте файлы до\u00A0100\u00A0ГБ',
            key: 'gb100',
            icon: <DoneIcon fill="#005FF9" width={16} height={16} />,
        },
        {
            text: '60 дней истории изменений файлов',
            key: 'hist',
            icon: <DoneIcon fill="#005FF9" width={16} height={16} />,
        },
        {
            text: 'Автоудаление папок',
            key: 'autodelete',
            icon: <DoneIcon fill="#005FF9" width={16} height={18} />,
        },
        {
            key: 'disko',
            text: 'Лицензия Диск-О: на год в подарок',
            icon: <DiskoIcon width={16} height={16} />,
            onClick: openDisko,
        },
        {
            text: 'бесплатно на 3\u00A0месяца',
            key: 'combo',
            icon: <ComboNewIcon width={92} height={23} />,
            delimiters: true,
        },
    ],
    professional_new6M: [
        {
            text: 'Без рекламы',
            key: 'noads',
            icon: <DoneIcon fill="#005FF9" width={16} height={16} />,
        },
        {
            text: 'Загружайте файлы до\u00A0100\u00A0ГБ',
            key: 'gb100',
            icon: <DoneIcon fill="#005FF9" width={16} height={16} />,
        },
        {
            text: '60 дней истории изменений файлов',
            key: 'hist',
            icon: <DoneIcon fill="#005FF9" width={16} height={16} />,
        },
        {
            text: 'Автоудаление папок',
            key: 'autodelete',
            icon: <DoneIcon fill="#005FF9" width={16} height={18} />,
        },
        {
            text: 'Лицензия Диск-О: на 6\u00A0месяцев в подарок',
            key: 'disko',
            icon: <DiskoIcon width={16} height={16} />,
            onClick: openDisko,
        },
        {
            text: 'бесплатно на 1\u00A0месяц',
            key: 'combo',
            icon: <ComboNewIcon width={92} height={23} />,
            delimiters: true,
        },
    ],
    capsule1st: [
        {
            text: '1 ТБ в Облаке на год',
            key: 'year1',
            icon: <DoneIcon fill={theme.colorPrimary.normal} />,
        },
        {
            text: 'Без рекламы',
            key: 'noads',
            icon: <DoneIcon fill={theme.colorPrimary.normal} />,
        },
        {
            text: 'Загружайте файлы до 32 ГБ',
            key: 'big',
            icon: <DoneIcon fill={theme.colorPrimary.normal} />,
        },
        {
            text: '30 дней истории изменений',
            key: 'hist',
            icon: <DoneIcon fill={theme.colorPrimary.normal} />,
        },
        {
            text: 'Автоудаление папок',
            key: 'autodelete',
            icon: <DoneIcon fill={theme.colorPrimary.normal} />,
        },
        {
            text: 'Звонки с помощью Капсулы',
            key: 'vk',
            icon: <DoneIcon fill={theme.colorPrimary.normal} />,
        },
        {
            text: 'Персональные плейлисты',
            key: 'playlist',
            icon: <DoneIcon fill={theme.colorPrimary.normal} />,
        },
        {
            text: 'Детские сказки от голосового помощника Маруси',
            key: 'music',
            icon: <DoneIcon fill={theme.colorPrimary.normal} />,
        },
    ],

    capsule2nd: [
        {
            text: 'Покупка осуществляется на сайте<br />capsula.mail.ru',
            key: 'buy',
            icon: <CartIcon />,
        },
        {
            text: 'После покупки на указанную почту<br />придёт письмо с промокодом на 1 ТБ<br />в Облаке',
            key: 'promo',
            icon: <MailIcon />,
        },
        {
            text: 'При активации промокода привязка<br />карты обязательна!',
            key: 'card',
            icon: <AccessIcon />,
        },
    ],

    business: [
        {
            text: 'Оплата по счету для юрлиц',
            key: 'business',
            icon: <MarkIcon width={13} height={11} />,
        },
        {
            text: 'Любой объем Облака по запросу',
            key: 'space',
            icon: <MarkIcon width={13} height={11} />,
        },
        {
            text: 'Без рекламы',
            key: 'noads',
            icon: <MarkIcon width={13} height={11} />,
        },
        {
            text: 'Автоудаление папок',
            key: 'autodelete',
            icon: <MarkIcon width={13} height={11} />,
        },
        {
            text: 'Загружайте файлы любого размера без ограничений',
            key: 'nolimits',
            icon: <MarkIcon width={13} height={11} />,
        },
        {
            text: '60 дней истории изменения файлов',
            key: 'hist',
            icon: <MarkIcon width={13} height={11} />,
        },
    ],

    paidWithIcon: [
        {
            text: 'Без рекламы',
            key: 'noads',
            icon: <DoneIcon fill="#005FF9" width={16} height={16} />,
        },
        {
            text: 'Загрузка файлов до\u00A032\u00A0ГБ',
            key: 'upload',
            icon: <DoneIcon fill="#005FF9" width={14} height={15} />,
        },
        {
            text: 'Автоудаление папок',
            key: 'autodelete',
            icon: <DoneIcon fill="#005FF9" width={16} height={18} />,
        },
        {
            text: 'Версионирование',
            key: 'version',
            icon: <DoneIcon fill="#005FF9" width={16} height={16} />,
        },
    ],

    action: [
        {
            text: 'Без рекламы',
            key: 'noads',
            icon: <DoneIcon fill={theme.colorPrimary.normal} />,
        },
        {
            text: 'Загрузка файлов до\u00A032\u00A0ГБ',
            key: 'upload',
            icon: <DoneIcon fill={theme.colorPrimary.normal} />,
        },
        {
            text: 'Автоудаление папок',
            key: 'autodelete',
            icon: <DoneIcon fill={theme.colorPrimary.normal} />,
        },
        {
            text: 'Версионирование',
            key: 'version',
            icon: <DoneIcon fill={theme.colorPrimary.normal} />,
        },
    ],
    overquota: [
        {
            text: 'Ваши файлы остаются в сохранности',
            key: 'save',
            icon: <DoneIcon fill={theme.colorPrimary.normal} />,
        },
        {
            text: 'Загрузка файлов до\u00A032\u00A0ГБ',
            key: 'upload',
            icon: <DoneIcon fill={theme.colorPrimary.normal} />,
        },
        {
            text: 'Автоудаление папок',
            key: 'autodelete',
            icon: <DoneIcon fill={theme.colorPrimary.normal} />,
        },
        {
            text: 'Никакой рекламы',
            key: 'noads',
            icon: <DoneIcon fill={theme.colorPrimary.normal} />,
        },
    ],
};

export default {
    ...baseFeatures,
    ...quotaFeatures,
};
